import { render } from "./allstockadjustment.vue?vue&type=template&id=b1a604be"
import script from "./allstockadjustment.vue?vue&type=script&lang=js"
export * from "./allstockadjustment.vue?vue&type=script&lang=js"

import "./allstockadjustment.vue?vue&type=style&index=0&id=b1a604be&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__